// src/lib/JuicePlugin.ts
import { createSlatePlugin, HtmlPlugin } from "@udecode/plate";
import juice from "juice";
var JuicePlugin = createSlatePlugin({
  key: "juice",
  inject: {
    plugins: {
      [HtmlPlugin.key]: {
        parser: {
          transformData: ({ data }) => {
            let newData = data.replaceAll(/<style>\s*<!--/g, "<style>");
            newData = juice(newData);
            return newData;
          }
        }
      }
    }
  }
});
export {
  JuicePlugin
};
//# sourceMappingURL=index.mjs.map